// extracted by mini-css-extract-plugin
export default {"root":"ProvidedDomainList-root_CyZSH","unavailable":"ProvidedDomainList-unavailable_xvsED"};